var BASWebServices;
(function (BASWebServices) {
    var VersionController = (function () {
        function VersionController($scope, vs) {
            this.$scope = $scope;
            this.vs = vs;
            $scope.vc = this;
            var _scope = $scope;
            vs.getVersionPromise("runAnonymizer").then(function successCallback(response) {
                _scope.ANONYMIZER_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runAnnotConv").then(function successCallback(response) {
                _scope.ANNOTCONV_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runASR").then(function successCallback(response) {
                _scope.ASR_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runAudioEnhance").then(function successCallback(response) {
                _scope.AUDIOENHANCE_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runChannelSeparator").then(function successCallback(response) {
                _scope.CHANNELSEPARATOR_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runChunker").then(function successCallback(response) {
                _scope.CHUNKER_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runChunkPreparation").then(function successCallback(response) {
                _scope.CHUNKPREPARATION_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runCOALA").then(function successCallback(response) {
                _scope.COALA_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runEMUMagic").then(function successCallback(response) {
                _scope.EMUMAGIC_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runFormantAnalysis").then(function successCallback(response) {
                _scope.FORMANTANALYSIS_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runG2P").then(function successCallback(response) {
                _scope.G2P_VERSION = response.data;
            }, function (response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runMAUS").then(function successCallback(response) {
                _scope.MAUS_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runMINNI").then(function successCallback(response) {
                _scope.MINNI_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runPho2Syl").then(function successCallback(response) {
                _scope.PHO2SYL_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runPipeline").then(function successCallback(response) {
                _scope.PIPELINE_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runPipelineWithASR").then(function successCallback(response) {
                _scope.PIPELINEWITHASR_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runSpeakDiar").then(function successCallback(response) {
                _scope.SPEAKDIAR_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runSubtitle").then(function successCallback(response) {
                _scope.SUBTITLE_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runTextEnhance").then(function successCallback(response) {
                _scope.TEXTENHANCE_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("runVoiceActivityDetection").then(function successCallback(response) {
                _scope.VAD_VERSION = response.data;
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
            vs.getVersionPromise("services").then(function successCallback(response) {
                _scope.WEBSERVICE_VERSION = response.data;
                _scope.WEBSERVICE_VERSION = _scope.WEBSERVICE_VERSION.trim();
            }, function errorCallback(response) {
                console.error("Something went wrong trying to get the version url: " + response.data);
            });
        }
        return VersionController;
    }());
    BASWebServices.VersionController = VersionController;
})(BASWebServices || (BASWebServices = {}));
//# sourceMappingURL=VersionController.js.map